import Vue from "vue";
import store from "@/store";
const checkLogin = function (isShow = null) {
    let userInfo = localStorage.getItem("userInfo");
    if (!userInfo) {
        if (!isShow) store.commit("setLoginVisible", true);
        return false;
    }
    userInfo = JSON.parse(userInfo);
    if (
        !userInfo.hasOwnProperty("expirationTime") ||
        !userInfo.hasOwnProperty("token") ||
        !userInfo.hasOwnProperty("userPhone")
    ) {
        if (!isShow) store.commit("setLoginVisible", true);
        return false;
    }
    var dateBegin = new Date(); //获取当前时间
    var dateEnd = new Date(userInfo.expirationTime); //获取token过期时间
    var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
    var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
    if (hours >= 24 || dateDiff <= 0) {
        if (!isShow) store.commit("setLoginVisible", true);
        return false;
    }
    return true;
};
Vue.prototype.$checkLogin = checkLogin;
export default checkLogin;
